import { Badge } from '@amzn/awsui-components-react';
import { Order } from '@amzn/ito-client';

/** Product, requester and order-reference badges, used in confirm-modal headers across BulkOrders and ManageOrders. */
export function buildOrderReferenceBadges(order?: Order): JSX.Element[] {
    const tags: JSX.Element[] = [];
    if (order?.display) {
        tags.push(<Badge key="product" color="blue">{order.display}</Badge>);
    }
    const requesterAlias = order?.requester?.userAlias || order?.requester?.basicInfo?.username;
    if (requesterAlias) {
        tags.push(<Badge key="requester" color="grey">{requesterAlias}</Badge>);
    }
    if (order?.orderReference) {
        tags.push(<Badge key="orderReference" color="green">{order.orderReference}</Badge>);
    }
    return tags;
}
